import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import LandingPage from "./content/LandingPage";
import axiosInt from "./apis/configs/axiosConfig";
import { Snackbar, Alert } from '@mui/material';

function App() {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, getAccessTokenSilently } = useAuth0();
  // config({ devextremeLicense });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  React.useEffect(() => {
    // https://marketplace.skypad.biz/?code=801A10BD64E448BC901462043012DF34&state=A0YFFJJQMD&sellerId=10001127277&type=auth&partnerType=seller&clientId=e4228aee-4f2a-43c8-85be-767aae78d8a7
    const handleWalmartCallback = async () => {
      if (window.location.href.includes('sellerId')) {
        localStorage.setItem('sellerId', window.location.href);
      }

      if (localStorage.getItem('sellerId')) {
        let urlNew = localStorage.getItem('sellerId');
        const urlParams = new URLSearchParams(urlNew);
        let code = urlParams.get('code');
        const state = urlParams.get('state');
        const sellerId = urlParams.get('sellerId');
        const type = urlParams.get('type');
        const partnerType = urlParams.get('partnerType');
        const clientId = urlParams.get('clientId');

        const match = urlNew.match(/[?&]code=([^&]+)/);
        code = match ? match[1] : null;

        let accessToken = await getAccessTokenSilently();
        axiosInt.post('walmart-token', {
          code,
          state,
          sellerId,
          type,
          partnerType,
          clientId
        }, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          }
        }).then((response) => {
          console.log(response);
          localStorage.removeItem('sellerId');
          setOpen(true);
          setMessage(
            <>
              User has been connected successfully.
            </>
          );
        }).catch((error) => {
          alert('Connection failed, please try again later');
          console.log(error);
        });
      }
    };
    handleWalmartCallback();
  }, []);


  React.useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
      } else {
        loginWithRedirect();
      }
    }
  }, [isAuthenticated, isLoading]);

  const connectToWalmart = async () => {

    let accessToken = await getAccessTokenSilently();
    axiosInt.get('walmart-url', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    }).then((response) => {
      window.location.href = response.data.url;
    }).catch((error) => {
      alert('Please try again later');
      console.log(error);
    });
  }

  const disconnect = async () => {

    let accessToken = await getAccessTokenSilently();
    axiosInt.post('removeToken', {}, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      }
    }).then((response) => {
      setOpen(true);
      setMessage(
        <>
          Access Removed, please contact{' '}
          <a href="mailto:asquad@skyitgroup.com" style={{ color: '#0288d1', fontWeight: 'bold' }}>
            asquad@skyitgroup.com
          </a>{' '}
          if this was done in error.
        </>
      );
      console.log(response);
    }).catch((error) => {
      setOpen(true);
      setMessage('There was an error. Please try again later.');
      console.log(error);
    });
  }

  return isAuthenticated && !isLoading && (<>
    <LandingPage connectToWalmart={connectToWalmart} disconnect={disconnect} logout={logout} />
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity="info"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  </>
  )

}
export default App;

